function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, React.createElement("filter", {
  id: "arrow_inline_svg__3j4begoixa",
  width: "108.8%",
  height: "215%",
  x: "-4.4%",
  y: "-57.5%",
  filterUnits: "objectBoundingBox"
}, React.createElement("feOffset", {
  dy: 4,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 10
}), React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), React.createElement("feMerge", null, React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#arrow_inline_svg__3j4begoixa)",
  transform: "translate(-646 -28)",
  fill: "#212121",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M657.863 43.891l3.682-3.625a.378.378 0 00.003-.53l-3.682-3.626a.374.374 0 00-.53 0l-.223.222a.375.375 0 000 .531l3.194 3.138-3.197 3.137a.376.376 0 000 .532l.222.221a.375.375 0 00.531 0z"
}));

function SvgArrowinline(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
}

export default SvgArrowinline;